/** Presentation only: no choices, child data or progress persistence. */
import type { RuntimeClip } from "../../shared/assets";

/** Exponer significa seguir mostrando el objeto sostenido, no duplicarlo. */
export function brujulaEnManos(presentacion: PresentacionBrujula | undefined): boolean {
  return presentacion?.ubicacion === "mano-capi" || presentacion?.ubicacion === "exposicion";
}

/** La acción del objeto requiere el mismo plano durante toda la explicación. */
export function encuadreConBrujula(preset: string, presentacion: PresentacionBrujula | undefined): string {
  return brujulaEnManos(presentacion) ? "compass_closeup" : preset;
}

export function clipConBrujula(clip: RuntimeClip, sostiene: boolean): RuntimeClip {
  if (!sostiene || clip === "GiveObject" || clip === "Walk" || clip === "Roll" || clip === "Jump") return clip;
  return "HoldObject";
}

export type PresentacionBrujula =
  | { readonly ubicacion: "oculta"; readonly accion: "ninguna" }
  | { readonly ubicacion: "mano-capi"; readonly accion: "ofrecer" | "sostener" }
  | { readonly ubicacion: "exposicion"; readonly accion: "mostrar" }
  | { readonly ubicacion: "hud"; readonly accion: "colocar" };

/** Explicit node identities preserve the compass between explanatory lines.
 * No transfer to an invisible player; giving means offering it for inspection.
 */
export function presentacionBrujula(sceneId: string, nodeId: string): PresentacionBrujula {
  if (sceneId !== "s02_brujula") return { ubicacion: "oculta", accion: "ninguna" };
  if (nodeId === "s02_n001") return { ubicacion: "mano-capi", accion: "ofrecer" };
  if (nodeId === "s02_n002") return { ubicacion: "mano-capi", accion: "sostener" };
  if (["s02_n003", "s02_n004", "s02_n005", "s02_n006", "s02_n007", "s02_m001"].includes(nodeId)) {
    return { ubicacion: "exposicion", accion: "mostrar" };
  }
  if (nodeId === "s02_n008") return { ubicacion: "hud", accion: "colocar" };
  return { ubicacion: "oculta", accion: "ninguna" };
}
